import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "app-confirm-overrride",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.scss"],
})
export class ConfirmComponent {
  message = " ";
  title = "Alert!";
  okAction = "Ok";

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {
    this.message = Data.message;
    this.title = Data.title ?? this.title;
    this.okAction = Data.okAction ?? this.okAction;
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
